// src/components/zones/MarginalShallows/ShallowsCreatures.jsx
import React from 'react';
import Arapaima from './Arapaima.jsx';         
import SwimmingSilverCroaker from './SilverCroaker.jsx';

// robust env flag (defaults ON)
const boolEnv = (key, def = true) => {
  const raw = process.env[key];
  if (raw == null) return def;
  const v = String(raw).trim().toLowerCase();
  if (['1','true','yes','on'].includes(v)) return true;
  if (['0','false','no','off',''].includes(v)) return false;
  return def;
};

export default function ShallowsCreatures({
  zone,
  theme,
  onCreatureClick,
  highlightVersion,
}) {
  const showArapaima     = boolEnv('REACT_APP_SHOW_ARAPAIMA', true);
  const showSilverCroaker = boolEnv('REACT_APP_SHOW_SHALLOWS_CREATURES', true);

  const v0 = zone?.versions?.[0]; // Arapaima version
  const v1 = zone?.versions?.[1]; // Silver Croaker version

  const isHighlighted = (ver) =>
    highlightVersion != null && String(ver) === String(highlightVersion);

  const handleClick = (v, name) => {
    if (onCreatureClick) onCreatureClick(v);
    else console.warn('[ShallowsCreatures] click:', name, v);
  };

  return (
    <section className="relative w-full h-64 overflow-visible">
      {showArapaima && v0 && (
        <Arapaima
          /* Predator (Arapaima) */
          predatorWidth={110}
          predatorSpeed={2}
          predatorCatchRadius={20}
          predatorZ={90}

          /* School (Neon tetra) */
          schoolCount={22}
          schoolDuration="10s"
          schoolZ={80}

          /* Start predator visible/active immediately */
          startActive={true}                          // ⬅️ ensure it shows
          highlight={isHighlighted(v0.versionNumber)} // ⬅️ boolean, not a function
          theme={theme}
          onPredatorClick={() => handleClick(v0, 'Arapaima')}
        />
      )}

      {showSilverCroaker && v1 && (
        <SwimmingSilverCroaker
          width={120}
          swimDuration="50s"
          tailDuration="0.8s"
          minTop={80}
          maxTop={95}
          zIndex={30}
          highlight={isHighlighted(v1.versionNumber)}
          onClick={() => handleClick(v1, 'SilverCroaker')}
        />
      )}
    </section>
  );
}
